import { render, staticRenderFns } from "./recordTable.vue?vue&type=template&id=b8be4d40&scoped=true&"
import script from "./recordTable.vue?vue&type=script&lang=ts&"
export * from "./recordTable.vue?vue&type=script&lang=ts&"
import style0 from "./recordTable.vue?vue&type=style&index=0&id=b8be4d40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8be4d40",
  null
  
)

export default component.exports